// extracted by mini-css-extract-plugin
module.exports = {"HeroSection":"HeroSectionStatic_HeroSection__LHDJy","reviewsPositionCenter":"HeroSectionStatic_reviewsPositionCenter__PpDVc"};